import { createRouter, createWebHistory } from 'vue-router'
import routes from '@/micro/router'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router